import React, { useState } from "react";
import { inject, observer } from "mobx-react";
import { Dialog } from "@blueprintjs/core";
import TabSelector from "../common/TabSelector";
import "./MultiLevelRatingDialog.css";
import MultiLevelRatingMethod from "./MultiLevelRatingMethod";
import MultiLevelReviewSteps from "./MultiLevelReviewSteps";
const MultilevelSettingDialog = inject("ToastStore")(observer(({ isOpen, onClose, onSaveRatingMethod, defaultRatingMethod, globalReviewSteps, onSaveReviewSteps }) => {

  const [activeTab, setActiveTab] = useState("ratingMethod");

  const tabs = [
    { key: "ratingMethod", label: "Rating Method" },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case "ratingMethod":
        return <MultiLevelRatingMethod
          defaultValue={defaultRatingMethod}
          onSave={onSaveRatingMethod} />;
      case "globalReviewSteps":
        return <MultiLevelReviewSteps
          key={isOpen}
          globalReviewSteps={globalReviewSteps}
          onSave={onSaveReviewSteps}
          onCancel={onClose}
        // onSave={(formattedSteps) => {
        //     onSaveReviewSteps && onSaveReviewSteps(formattedSteps);
        //     onClose();
        //  }} 
        />;
      default:
        return null;
    }
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title="Rating and Review Settings"
      style={{ width: "850px", maxHeight: "80vh" }}
      portalContainer={document.body}
    >
      <div style={{ padding: "20px" }}>

        <TabSelector
          tabs={tabs}
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />

        <div style={{ marginTop: "20px" }}>
          {renderTabContent()}
        </div>
      </div>
    </Dialog>
  );
}));

export default MultilevelSettingDialog;